import { Directive, Input, Host, TemplateRef, ViewContainerRef, OnInit, DoCheck } from '@angular/core';
import { NgSwitch } from '@angular/common';

@Directive({
    selector: '[roblexSwitchCases]',
})
export class SwitchCasesDirective implements OnInit, DoCheck {
    /**
     * Ng switch of switch cases directive
     */
    private ngSwitch: any;
    /**
     * Created  of switch cases directive
     */
    private _created = false;
    /**
     * Input roblex switch cases of switch cases directive
     */
    @Input() roblexSwitchCases: any[];
    /**
     * Creates an instance of switch cases directive.
     * @param viewContainer ViewContainerRef
     * @param templateRef TemplateRef<Object>
     * @param ngSwitch NgSwitch
     */
    constructor(
        private viewContainer: ViewContainerRef,
        private templateRef: TemplateRef<Object>,
        @Host() ngSwitch: NgSwitch
    ) {
        this.ngSwitch = ngSwitch;
    }
    /**
     * on init
     */
    ngOnInit(): void {
        (this.roblexSwitchCases || []).forEach(() => this.ngSwitch._addCase());
    }
    /**
     * do check
     */
    ngDoCheck(): void {
        let enforce = false;
        (this.roblexSwitchCases || []).forEach(
            (value) => (enforce = this.ngSwitch._matchCase(value) || enforce)
        );
        this.enforceState(enforce);
    }
    /**
     * Enforces state
     * @param created boolean
     */
    enforceState(created: boolean): void {
        if (created && !this._created) {
            this._created = true;
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else if (!created && this._created) {
            this._created = false;
            this.viewContainer.clear();
        }
    }
}
